import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { NavigationService } from "abreact/incubator/ui/app/NavigationService";
import { RegisterDestroyListenerImpl } from "abweb/service/destroyListener/RegisterDestroyListenerImpl";
import { AsyncCallback1Arg } from "abweb/utils/callback/AsyncCallback1Arg";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { makeObservable, observable, runInAction } from "mobx";
const LOG = LogUtils.getLogger(__filename);
export let BaseRouteRenderContext = (_class = class BaseRouteRenderContext extends RegisterDestroyListenerImpl {
  constructor(name, navSvc) {
    super();
    _defineProperty(this, "routerEventListeners", new AsyncCallback1Arg());
    _defineProperty(this, "_isDestroyed", false);
    _defineProperty(this, "_navSvc", void 0);
    _initializerDefineProperty(this, "_currentRouteHandler", _descriptor, this);
    /////////////////// Event Processing //////////////////
    _defineProperty(this, "routerEventHandlerFn",
    // NavigationService broadcasts route events for all RouteRenderContext areas,
    // so only fire this routeRenderContext's event listeners if the event is for this RouteRenderContext
    async routeEvent => {
      if (routeEvent.routeRenderContext === this) {
        await this.routerEventListeners.callAll(routeEvent);
      }
    });
    this.name = name;
    this._navSvc = navSvc;
    this._currentRouteHandler = null;
    makeObservable(this);
  }
  get navSvc() {
    // SecondaryRRC has this._navSvc defined, but primaryRRC doesn't as causes cycles, so just dynamically get it.
    return this._navSvc ?? NavigationService.getSingleton();
  }
  destroyGuard() {
    if (this.isDestroyed) {
      throw new Error(`The RouteRenderContext with name='${this.name}' has been destroyed, and can not be used after it has been destroyed.`);
    }
  }
  get isDestroyed() {
    return this._isDestroyed;
  }
  get currentRouteHandler() {
    // During interactive browser debugging against a devserver, currentRouteHandler is sometimes called after an
    // RRC instance has been destroyed (maybe deferred React render cycle?), so don't call this destroyGuard
    // for a better debugging experience...   Also this is a stateless method (doesn't change any state).
    // this.destroyGuard();
    return this._currentRouteHandler;
  }

  /**
   * Application devs should never call this,
   * only invoked by NavigationService on route change workflows (e.g., goto and href workflows)
   */
  set currentRouteHandler(value) {
    this.destroyGuard();
    runInAction(() => this._currentRouteHandler = value);
  }
  destroy() {
    if (this.isDestroyed) {
      LOG.info(`RouteRenderContext with name='${this.name}' has already been destroyed, subsequent destroy() call ignored.`);
      return Promise.resolve();
    }
    this._isDestroyed = true;

    // Cleanup route event registration if there are any event listeners
    if (this.routerEventListeners.listenerCount > 0) {
      this.routerEventListeners.removeAllCallbacks();
      // Below throws if removeCallback that isn't currently registered
      this.navSvc.removeCallback(this.routerEventHandlerFn);
    }

    // Defensively log RRC destroys in case destroyGuard unexpectedly starts being triggered
    LOG.info(`RouteRenderContext with name='${this.name}' has been destroyed.`);

    // Notify interested callers that this RRC instance has been destroyed
    return this.destroyListenerMgr.destroyAll();
  }
  addCallback(listener) {
    /*const unsub = */
    this.routerEventListeners.addCallback(listener);
    // First one in, turn on the lights
    if (this.routerEventListeners.listenerCount === 1) {
      this.navSvc.addCallback(this.routerEventHandlerFn);
    }
    // Make our own so that it lazily 'turns off the lights' on unsub().
    return () => this.removeCallback(listener);
  }
  removeCallback(listener) {
    this.routerEventListeners.removeCallback(listener);
    // Last one out, turn off the lights
    if (this.routerEventListeners.listenerCount === 0) {
      this.navSvc.removeCallback(this.routerEventHandlerFn);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_currentRouteHandler", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
//# sourceMappingURL=BaseRouteRenderContext.js.map
